exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4a8c8860] .el-tabs__header{margin-bottom:0}.gd-width[data-v-4a8c8860]{width:auto}", ""]);

// exports
